import { IPrincipal } from "@interfaces/common.interfaces";
import { IApplicationRoleMembership } from "@interfaces/settings/permissions.interfaces";
import { ILocaleStrings } from "loc/locale.interfaces";


export const getAsPrincipal = (membership: IApplicationRoleMembership): IPrincipal => {
    return {
        displayName: membership.displayName,
        objectId: membership.objectId,
        upn: membership.upn || membership.displayName,
        email: ""
    };
};